import React from 'react'
import { map, uniq, find, toString, toLower, isBlank, sortBy, startCase } from 'lodash'
import Select from 'UI/Select'

const defaultFilters = {
  customers: 'All',
  locations: 'All',
  function: 'All',
  ownership: 'All',
  powerState: 'All',
  customerStatus: 'All',
  ratio: 4,
  nPlus: 1
}

const Filters = ({ filters, changeFilters, customers, locations, clusters }) => {
  const filterOptions = {
    powerState: ['All', 'On', 'Off'],
    function: map(['All', ...uniq(map(clusters, 'function'))], value => ({ value, label: value })),
    ownership: map(['All', ...uniq(map(clusters, 'ownership'))], value => ({ value, label: value })),
    nPlus: [{ label: "Don't use N+", value: false }, { label: 'N + 1', value: 1 }],
    locations: sortBy(locations, 'label'),
    customers: sortBy(customers, 'label'),
    customerStatuses: map(['live', 'historic', 'pending offboarding'], status => (
      { value: status, label: startCase(status) }
    ))
  }

  return (
    <div className="row mb-3">
      <div className="col">
        <label>Location</label>
        <Select
          isMulti
          value={find(filterOptions.locations, ({ value }) => toLower(toString(filters.locations)) === toLower(toString(value)))}
          options={filterOptions.locations}
          onChange={options => changeFilters({ ...filters, locations: isBlank(options) ? 'All' : options })}
        />
      </div>

      <div className="col">
        <label>Customer</label>
        <Select
          isMulti
          value={find(filterOptions.customers, ({ value }) => toLower(toString(filters.customers)) === toLower(toString(value)))}
          options={filterOptions.customers}
          onChange={options => changeFilters({ ...filters, customers: isBlank(options) ? 'All' : options })}
        />
      </div>
      <div className="col">
        <label>Customer status</label>
        <Select
          isMulti
          value={find(filterOptions.customerStatues, ({ value }) => toLower(toString(filters.customerStatuses)) === toLower(toString(value)))}
          options={filterOptions.customerStatuses}
          onChange={options => changeFilters({ ...filters, customerStatus: isBlank(options) ? 'All' : options })}
        />
      </div>

      <div className="col">
        <label>Function</label>
        <Select
          value={find(filterOptions.function, ({ value }) => toLower(toString(filters.function)) === toLower(toString(value)))}
          options={filterOptions.function}
          onChange={option => changeFilters({ ...filters, function: option.value })}
        />
      </div>

      <div className="col">
        <label>Ownership</label>
        <Select
          value={find(filterOptions.ownership, ({ value }) => toLower(toString(filters.ownership)) === toLower(toString(value)))}
          options={filterOptions.ownership}
          onChange={option => changeFilters({ ...filters, ownership: option.value })}
        />
      </div>

      <div className="col">
        <label>Power State</label>
        <Select
          defaultValue={{ label: 'All', value: 'All' }}
          value={find(filterOptions.powerState, ({ value }) => toLower(toString(filters.powerState)) === toLower(toString(value)))}
          options={map(filterOptions.powerState, value => ({ value, label: value }))}
          onChange={option => changeFilters({ ...filters, powerState: option.value })}
        />
      </div>

      <div className="col">
        <label>N+</label>
        <Select
          value={find(filterOptions.nPlus, ({ value }) => toLower(toString(filters.nPlus)) === toLower(toString(value)))}
          options={filterOptions.nPlus}
          onChange={option => changeFilters({ ...filters, nPlus: option.value })}
        />
      </div>

      <div className="col">
        <label>CPU Ratio</label>
        <input
          type="number"
          value={filters.ratio}
          onChange={(event) => changeFilters({ ...filters, ratio: parseInt(event.target.value) })}
        />
      </div>
    </div>
  )
}

export { Filters, defaultFilters }
